import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initialiseUsage } from './api/usage'
import { App } from './App'
import './styles/index.css'

// Before the router runs, which may rewrite the address and with it the landing UTM parameters.
initialiseUsage()

const container = document.getElementById('root')
if (!container) {
  throw new Error('The #root element is missing from index.html.')
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
